import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
const bgColors = {
    emphasis: 'bg-emphasis',
    gray: 'bg-gray-300',
    info: 'bg-info',
    lightGray: 'bg-light-gray',
};
const spaces = {
    none: '',
    normal: 'p-16',
    wide: 'p-20',
};
export const ColorPaper = (props) => {
    const { bgColor, children, className, space = 'normal' } = props;
    return (_jsx("div", Object.assign({ className: clsx('rounded-md', bgColors[bgColor], spaces[space], className) }, { children: children })));
};
